export class Message {
    constructor(
      public id: string,
      public group: any,
      public category: any,
      public isRead: boolean,
      public title: string,
      public text: string,
      public folder: string,
      public user: any,
      public users: any[],
      public sendAsEmail: boolean,
      public receiversCanNotAnswer: boolean,
      public canAnswer: boolean,
      public canReadAnswer: boolean,
      public date: Date,
      public updateDate: Date,
      public source: string,
      public audio?: string,
      public image?: string,
      public document?: string,
      public images?: any,
      public documents?: any,
      public documentNames?: any,
      public documentName?: any,
      public roles?: any[],
      public groups?: any[],
      public isImportant?: boolean,
      public isNotifySecret?: boolean,
      public regarding?: string,
      public textDelta?: string,
    ) { }
  }



// WEBPACK FOOTER //
// ./src/app/messages/shared/message.model.ts